/** The Edgebook mark: a green candle shaped like a bookmark ribbon. Inline so it follows the theme. */
export default function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <svg className="brand-mark" viewBox="0 0 48 48" width={size} height={size} aria-hidden="true">
      <path d="M24 4.5v7" fill="none" stroke="var(--text)" strokeWidth="4.2" strokeLinecap="round" />
      <path d="M15 13h18v29l-9-6l-9 6z" fill="var(--brand)" stroke="var(--brand)" strokeWidth="4" strokeLinejoin="round" />
      <path d="M19.5 17.5v12.5" fill="none" stroke="var(--brand-hi)" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
